import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Logo } from "../site/Logo";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (user) return children;

  if (loading) {
    return (
      <div className="min-h-screen bg-void flex flex-col items-center justify-center gap-6 text-white">
        <Logo size={34} />
        <span className="h-5 w-5 rounded-full border-2 border-brand border-t-transparent animate-spin" />
      </div>
    );
  }

  return <Navigate to="/admin/login" replace />;
}
